export default __webpack_public_path__ + "fonts/close-account-special-offer-pending-bg.svg";